const isProduction = (location = window.location): boolean => {
  return /^omella.com$/i.test(location.host);
};

export default isProduction;
